export default (theme) => ({
  navBar: {
    position: 'fixed',
    background: theme.palette.background.white,
    zIndex: 1000,
    top: 0,
    left: 0,
    right: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: 90,
    width: '100%',
    padding: '18px 45px',
    boxShadow: theme.custom.boxShadow,
    WebkitBoxShadow: theme.custom.boxShadow,
    [theme.breakpoints.down('xl')]: {
      height: 80,
    },
    [theme.breakpoints.down('md')]: {
      justifyContent: 'center',
      padding: 16,
      height: 70,
    },
  },
  logoWrapper: {
    width: 68,
    height: 68,
    objectFit: 'contain',
    objectPosition: 'center',
    [theme.breakpoints.down('md')]: {
      width: 50,
      height: 50,
    },
  },
  mobileIcon: {
    width: '100%',
    height: 'auto',
    objectFit: 'contain',
    objectPosition: 'center',
  },
  tabs: {
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  userIcon: {
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
});
